import React, {
    createContext,
    ReactNode,
    useContext,
    useMemo,
    useState,
} from "react";

import { BookingModalContextValues } from "../types/contexts";
import { BookingModalContent } from "../types/opengames";
import { AsyncStatuses } from "../../../types/shared";

const BookingModalContext = createContext<BookingModalContextValues | null>(
    null,
);

export const useBookingModalContext = () => {
    const context = useContext(BookingModalContext);
    if (!context) {
        throw new Error(
            "useBookingModalContext must be used within a BookingModalProvider",
        );
    }
    return context;
};

export const BookingModalProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [showBookingModal, setShowBookingModal] = useState<boolean>(false);
    const [bookingModalContent, setBookingModalContent] =
        useState<BookingModalContent>();
    const [bookingStatus, setBookingStatus] =
        useState<AsyncStatuses>(undefined);
    const [bookingStatusMessage, setBookingStatusMessage] = useState<
        string | undefined
    >(undefined);

    const contextValue = useMemo(
        () => ({
            bookingModalContent,
            setBookingModalContent,
            showBookingModal,
            setShowBookingModal,
            bookingStatus,
            setBookingStatus,
            bookingStatusMessage,
            setBookingStatusMessage,
        }),
        [
            showBookingModal,
            bookingModalContent,
            bookingStatus,
            bookingStatusMessage,
        ],
    );

    return (
        <BookingModalContext.Provider value={contextValue}>
            {children}
        </BookingModalContext.Provider>
    );
};
